import { Controller } from 'react-hook-form'
import { usePatientFormContext } from '../../context/PatientFormContext'

import { patientFormErrors } from '../../_errors'
import { useFormContextPatient } from '../_utils'
import PatientFormField from '../PatientFormField'

const Sex = () => {
    const { control, setError, trigger } = useFormContextPatient()

    const {
        state: { isDisabled },
    } = usePatientFormContext()

    const sexOptions = [
        {
            label: 'Masculin',
            value: 'm',
        },
        {
            label: 'Féminin',
            value: 'f',
        },
        {
            label: 'Indéterminé',
            value: 'i',
        },
    ]

    const getSex = (raw: string | undefined) =>
        raw ? sexOptions.find((option) => option.value === raw.toLowerCase()) : undefined

    return (
        <Controller
            control={control}
            name="sex"
            rules={{
                required: patientFormErrors.sex?.required,
                validate: (val) => Boolean(val),
            }}
            render={({ field, fieldState: { error } }) => (
                <PatientFormField
                    variant="select"
                    type="default"
                    label="Sexe"
                    name={field.name}
                    status={{
                        error,
                        valid: Boolean(field.value),
                    }}
                    required
                    placeholder="Choisir"
                    value={field.value ?? undefined}
                    onChange={(e) => {
                        field.onChange(e)
                        trigger('insNum')
                    }}
                    options={sexOptions}
                    disabled={isDisabled}
                    renderLabel={() => (field?.value ? getSex(field?.value)?.label : undefined)}
                    onClose={() => {
                        if (!field.value) {
                            setError('sex', {
                                message: '',
                            })
                        }
                    }}
                    dataCyScope="PatientField"
                />
            )}
        />
    )
}

export default Sex
